import React from 'react';

export default function ToggleTeamsCard(props) {
    return (
        <div className="card-header">
            <button
                className="btn btn-primary pull-right"
                type="button"
                data-toggle="collapse"
                data-target="#settingsTeamsCollapse"
                aria-expanded="false"
                aria-controls="settingsTeamsCollapse"
            >
                <span className="if-collapsed">Uitklappen</span>
                <span className="if-not-collapsed">Inklappen</span>
            </button>
            <h4>Teams</h4>
        </div>
    );
}